import { useEffect, useState } from "react";

import styles from "../../../../styles/beneficios/steps/BenefitTypeSelectStepOld.module.scss";

import classNames from "classnames/bind";
import { Button } from "../../../components/Button";
import { Hairline } from "../../../components/Hairline";
import { Label } from "../../../components/Label";
import { Message } from "../../../components/Message";
import { Radio } from "../../../components/Radio";
import { TimeInput } from "../../../components/TimeInput";
import { Icon } from "../../../components/core/Icon";
const css = classNames.bind(styles);

const days = [
  {
    key: 0,
    short: "D",
    full: "domingo",
  },
  {
    key: 1,
    short: "S",
    full: "segunda-feira",
  },
  {
    key: 2,
    short: "T",
    full: "terça-feira",
  },
  {
    key: 3,
    short: "Q",
    full: "quarta-feira",
  },
  {
    key: 4,
    short: "Q",
    full: "quinta-feira",
  },
  {
    key: 5,
    short: "S",
    full: "sexta-feira",
  },
  {
    key: 6,
    short: "S",
    full: "sábado",
  },
];

export default function BenefitVisibilityOld({
  benefit,
  creativeVisibility,
  onChange,
}) {
  const [visibility, setVisibility] = useState(creativeVisibility || null);

  useEffect(() => {
    if (!!visibility) {
      const removeColons = (array) => {
        return array.map((item) => ({
          ...item,
          start: item.start.replace(/:/g, ""),
          end: item.end.replace(/:/g, ""),
        }));
      };

      const updatedVisibility = visibility.map((weekDay) => ({
        ...weekDay,
        times: removeColons(weekDay.times),
      }));

      onChange({
        ...benefit,
        visibility: updatedVisibility,
      });

      return;
    }

    onChange({
      ...benefit,
      visibility: null,
    });
  }, [visibility]);

  const isSelectedDay = (day) => {
    return visibility.some((d) => d.weekDay === day);
  };

  const selectDaysWeek = (day) => {
    setVisibility((prevVisibility) => {
      const updatedVisibility = [...prevVisibility];

      const targetObject = updatedVisibility.find((obj) => obj.weekDay === day);

      if (targetObject) {
        updatedVisibility.splice(updatedVisibility.indexOf(targetObject), 1);
      } else {
        const weekDay = {
          type: "week_day",
          weekDay: day,
          times: [
            {
              start: "00:00",
              end: "12:00",
            },
          ],
        };
        updatedVisibility.push(weekDay);
        updatedVisibility.sort((a, b) => a.weekDay - b.weekDay);
      }

      return updatedVisibility;
    });
  };

  const addOrRemoveTime = (weekDay, newTime, indexToRemove) => {
    setVisibility((prevVisibility) => {
      const updatedVisibility = [...prevVisibility];

      const targetObject = updatedVisibility.find(
        (obj) => obj.weekDay === weekDay,
      );

      if (indexToRemove !== undefined && indexToRemove >= 0) {
        // Remover o tempo específico
        targetObject.times.splice(indexToRemove, 1);
      } else {
        // Adicionar novo tempo ao objeto existente ou criar um novo objeto
        if (targetObject) {
          targetObject.times.push(newTime);
        } else {
          const newObject = {
            type: "week_day",
            weekDay,
            times: [newTime],
          };
          updatedVisibility.push(newObject);
        }
      }

      return updatedVisibility;
    });
  };

  const changeTime = (weekDay, timeIndex, field, value) => {
    setVisibility((prevVisibility) => {
      const updatedVisibility = [...prevVisibility];

      const targetObject = updatedVisibility.find(
        (obj) => obj.weekDay === weekDay,
      );

      if (targetObject) {
        targetObject.times[timeIndex][field] = value;
      }

      return updatedVisibility;
    });
  };

  const checkTimeErrors = (weekDay) => {
    const conflicts = [];

    const targetObject = visibility.find((obj) => obj.weekDay === weekDay);

    if (targetObject && targetObject.times) {
      targetObject.times.forEach((time) => {
        if (time.start === time.end || time.start >= time.end) {
          conflicts.push({
            weekDay: weekDay,
            conflictingTime: time,
          });
        }
      });
    }

    return conflicts.length > 0;
  };

  // console.log('visibility', visibility)

  return (
    <>
      <Label>Este benefício deve ficar disponível</Label>
      <Radio
        family="availability"
        className="mb-10"
        value={true}
        checked={visibility === null}
        onChange={() => setVisibility(null)}
      >
        A todo momento
      </Radio>
      <Radio
        family="availability"
        value={true}
        checked={!!visibility}
        onChange={() => setVisibility([])}
      >
        Em momentos específicos
      </Radio>

      {!!visibility && (
        <>
          <Hairline />
          <Label text={"Disponibilidade na semana"} />
          <div className={styles.days}>
            {days.map((day) => (
              <div
                className={css({
                  day: true,
                  isSelected: isSelectedDay(day.key),
                })}
                onClick={() => selectDaysWeek(day.key)}
                key={day.full}
              >
                {day.short}
              </div>
            ))}
          </div>

          {visibility.map((v) => {
            const isIncluded = days.some((day) => day.key === v.weekDay);

            if (!isIncluded) return null;

            return (
              <div className={styles.times} key={v.weekDay}>
                <div className={styles.label}>
                  Horário <strong>{days[v.weekDay].full}:</strong>
                </div>
                {v.times.map((time, timeIndex) => {
                  const hourStart = time.start.substring(0, 2);
                  const minutesStart = time.start.substring(
                    time.start.length - 2,
                  );
                  const hourEnd = time.end.substring(0, 2);
                  const minutesEnd = time.end.substring(time.end.length - 2);

                  const startTime = hourStart + ":" + minutesStart;
                  const endTime = hourEnd + ":" + minutesEnd;

                  return (
                    <div className="d-flex align-stretch mt-30" key={timeIndex}>
                      <TimeInput
                        value={startTime}
                        onChange={(value) =>
                          changeTime(v.weekDay, timeIndex, "start", value)
                        }
                        label="De"
                        className="pt-0 mb-0 mr-20"
                      />
                      <TimeInput
                        value={endTime}
                        onChange={(value) =>
                          changeTime(v.weekDay, timeIndex, "end", value)
                        }
                        label="Até"
                        className="pt-0 mb-0 mr-20"
                      />
                      <Button
                        className="mr-15"
                        onClick={() =>
                          addOrRemoveTime(v.weekDay, {
                            start: "00:00",
                            end: "12:00",
                          })
                        }
                      >
                        <Icon name="plus" />
                      </Button>
                      <Button
                        onClick={() =>
                          addOrRemoveTime(v.weekDay, null, timeIndex)
                        }
                        disabled={v.times.length === 1}
                      >
                        <Icon name="trash-alt" />
                      </Button>
                    </div>
                  );
                })}

                {checkTimeErrors(v.weekDay) && (
                  <Message type="danger" className="mt-20">
                    Verifique os horários
                  </Message>
                )}
              </div>
            );
          })}
        </>
      )}
    </>
  );
}
